'use client';
import { useCallback } from 'react';
import { isFunction } from '@s7/utils';

const assignRef = (ref, value)=>{
    if (isFunction(ref)) {
        ref(value);
    } else if (ref !== null && ref !== undefined) {
        ref.current = value;
    }
};
const mergeRefs = (...refs)=>{
    return (node)=>refs.forEach((ref)=>assignRef(ref, node));
};
/**
 * Выполняет слияние ref.
 *
 * Мотивация использования useCallback:
 * https://github.com/gregberge/react-merge-refs/issues/5
 * */ const useMergedRefs = (...refs)=>{
    return useCallback(mergeRefs(...refs), refs);
};

export { assignRef, mergeRefs, useMergedRefs };
//# sourceMappingURL=useMergedRefs.js.map
